import { UtilsEnum } from '@/utils/UtilsEnum';

/** @type {EnumType<
 * 'ANALISE_RECOMENDACAO' |
 * 'ANALISE_EXCECAO' |
 * 'ANALISE_INVALIDO' |
 * 'ANALISE_EXPIRADO' |
 * 'ANALISE_DUPLICADO' |
 * 'ANALISE_DIVERGENTE' |
 * 'ANALISE_INATIVO' |
 * 'ANALISE_OPCIONAL'
 * >}
 */
export const AG_INPUT_FIELD_PRESET = UtilsEnum.create({
  ANALISE_RECOMENDACAO: {
    value: 'ANALISE_RECOMENDACAO',
    description: 'Análise - Recomendação',
    hint: 'Recomendação Agnes',
  },
  ANALISE_EXCECAO: {
    value: 'ANALISE_EXCECAO',
    description: 'Análise - Exceção',
    hint: 'Possui exceção',
  },
  ANALISE_INVALIDO: {
    value: 'ANALISE_INVALIDO',
    description: 'Análise - Inválido',
    hint: 'Inválido',
  },
  ANALISE_EXPIRADO: {
    value: 'ANALISE_EXPIRADO',
    description: 'Análise - Expirado',
    hint: 'Expirado',
  },
  ANALISE_DUPLICADO: {
    value: 'ANALISE_DUPLICADO',
    description: 'Análise - Duplicado',
    hint: 'Duplicado',
  },
  ANALISE_DIVERGENTE: {
    value: 'ANALISE_DIVERGENTE',
    description: 'Análise - Divergente',
    hint: 'Divergente',
  },
  ANALISE_INATIVO: {
    value: 'ANALISE_INATIVO',
    description: 'Análise - Inativo',
    hint: 'Inativo',
  },
  ANALISE_OPCIONAL: {
    value: 'ANALISE_OPCIONAL',
    description: 'Análise - Opcional',
    hint: 'Opcional',
  },
});
